/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_add } from './content/add.icon';
import { icon_add_box } from './content/add_box.icon';
import { icon_add_circle } from './content/add_circle.icon';
import { icon_add_circle_outline } from './content/add_circle_outline.icon';
import { icon_archive } from './content/archive.icon';
import { icon_clear } from './content/clear.icon';
import { icon_content_copy } from './content/content_copy.icon';
import { icon_create } from './content/create.icon';
import { icon_backspace } from './content/backspace.icon';
import { icon_block } from './content/block.icon';
import { icon_content_paste } from './content/content_paste.icon';
import { icon_filter_list } from './content/filter_list.icon';
import { icon_delete_sweep } from './content/delete_sweep.icon';
import { icon_content_cut } from './content/content_cut.icon';
import { icon_flag } from './content/flag.icon';
import { icon_forward } from './content/forward.icon';
import { icon_drafts } from './content/drafts.icon';
import { icon_font_download } from './content/font_download.icon';
import { icon_inbox } from './content/inbox.icon';
import { icon_gesture } from './content/gesture.icon';
import { icon_low_priority } from './content/low_priority.icon';
import { icon_link } from './content/link.icon';
import { icon_mail } from './content/mail.icon';
import { icon_remove } from './content/remove.icon';
import { icon_move_to_inbox } from './content/move_to_inbox.icon';
import { icon_markunread } from './content/markunread.icon';
import { icon_redo } from './content/redo.icon';
import { icon_reply } from './content/reply.icon';
import { icon_remove_circle } from './content/remove_circle.icon';
import { icon_next_week } from './content/next_week.icon';
import { icon_remove_circle_outline } from './content/remove_circle_outline.icon';
import { icon_report } from './content/report.icon';
import { icon_send } from './content/send.icon';
import { icon_save } from './content/save.icon';
import { icon_reply_all } from './content/reply_all.icon';
import { icon_sort } from './content/sort.icon';
import { icon_text_format } from './content/text_format.icon';
import { icon_select_all } from './content/select_all.icon';
import { icon_unarchive } from './content/unarchive.icon';
import { icon_undo } from './content/undo.icon';
import { icon_weekend } from './content/weekend.icon';
var icons = {
  "add" : icon_add,
"add_box" : icon_add_box,
"add_circle" : icon_add_circle,
"add_circle_outline" : icon_add_circle_outline,
"archive" : icon_archive,
"clear" : icon_clear,
"content_copy" : icon_content_copy,
"create" : icon_create,
"backspace" : icon_backspace,
"block" : icon_block,
"content_paste" : icon_content_paste,
"filter_list" : icon_filter_list,
"delete_sweep" : icon_delete_sweep,
"content_cut" : icon_content_cut,
"flag" : icon_flag,
"forward" : icon_forward,
"drafts" : icon_drafts,
"font_download" : icon_font_download,
"inbox" : icon_inbox,
"gesture" : icon_gesture,
"low_priority" : icon_low_priority,
"link" : icon_link,
"mail" : icon_mail,
"remove" : icon_remove,
"move_to_inbox" : icon_move_to_inbox,
"markunread" : icon_markunread,
"redo" : icon_redo,
"reply" : icon_reply,
"remove_circle" : icon_remove_circle,
"next_week" : icon_next_week,
"remove_circle_outline" : icon_remove_circle_outline,
"report" : icon_report,
"send" : icon_send,
"save" : icon_save,
"reply_all" : icon_reply_all,
"sort" : icon_sort,
"text_format" : icon_text_format,
"select_all" : icon_select_all,
"unarchive" : icon_unarchive,
"undo" : icon_undo,
"weekend" : icon_weekend,
};
export { icons };
